import React, { useState } from 'react';
import { LuTriangleAlert, LuPencil } from 'react-icons/lu';

// Zona del día y de dónde sale (25-oct-2026). La zona deja afuera lo de otras zonas (salvo lo que sumes a
// mano); cada una dice cuántos pedidos tiene y si hay urgentes. La salida es la base, el depósito de una
// empresa (donde está la camioneta) u otra dirección para ese día. El depósito se puede cargar o cambiar
// desde acá mismo: queda guardado en las Funciones del portal de esa empresa.
const ROTULO = 'block text-label font-black uppercase tracking-widest text-muted mb-1.5';
const chip = activo => `h-10 px-3 shrink-0 rounded-xl inline-flex items-center gap-1.5 text-label font-black active:scale-95 ${activo ? 'bg-ink text-page' : 'bg-panel text-secondary'}`;

export default function OpcionesArmarDia({ plan, zona, sinZona = false, onZona, onSalida, onOtraDireccion, onGuardarDeposito, onGuardarSalida, onQuitarSalida, guardando }) {
    const [editando, setEditando] = useState(false);
    const [texto, setTexto] = useState('');
    const [empresa, setEmpresa] = useState('GUARDAR');   // GUARDAR = queda entre las salidas · '' = solo este día · clienteId = su depósito
    const zonas = plan?.zonas || [];
    const salidas = plan?.salidas || [];
    const empresas = plan?.empresas || [];
    const total = zonas.reduce((a, z) => a + z.pedidos, 0);
    const abrir = () => {
        const actual = salidas.find(x => x.id === plan?.salidaId);
        setTexto(actual && actual.id !== 'BASE' && !actual.guardada ? actual.direccion || '' : '');
        setEmpresa('GUARDAR');
        setEditando(true);
    };
    const usar = async () => {
        const d = texto.trim();
        if (!d) return;
        const ok = empresa === 'GUARDAR' ? await onGuardarSalida(d) : empresa ? await onGuardarDeposito(Number(empresa), d) : await onOtraDireccion(d);
        if (ok !== false) setEditando(false);
    };
    return (
        <div className="space-y-3">
            {!sinZona && <div>
                <span className={ROTULO}>Zona</span>
                <div className="-mx-1 px-1 flex gap-1.5 overflow-x-auto pb-0.5">
                    <button type="button" onClick={() => onZona(null)} aria-pressed={!zona} className={chip(!zona)}>
                        Todas <span className="opacity-60">{total}</span>
                    </button>
                    {zonas.map(z => (
                        <button key={z.id} type="button" onClick={() => onZona(z.id)} aria-pressed={zona === z.id} className={chip(zona === z.id)}>
                            {z.nombre} <span className="opacity-60">{z.pedidos}</span>
                            {z.urgentes > 0 && <LuTriangleAlert size={13} className={zona === z.id ? '' : 'text-brand-red'} aria-label={`${z.urgentes} urgente${z.urgentes !== 1 ? 's' : ''}`} />}
                        </button>
                    ))}
                </div>
            </div>}
            <div>
                <span className={ROTULO}>Sale de</span>
                <div className="-mx-1 px-1 flex gap-1.5 overflow-x-auto pb-0.5">
                    {salidas.map(x => (
                        <button key={x.id} type="button" onClick={() => onSalida(x.id)} aria-pressed={plan?.salidaId === x.id} title={x.direccion || ''}
                            className={`${chip(plan?.salidaId === x.id)} max-w-[16rem]`}><span className="truncate">{x.nombre}</span></button>
                    ))}
                    <button type="button" onClick={abrir} className={chip(false)}><LuPencil size={13} /> Otra dirección</button>
                </div>
                {(() => {
                    const sel = salidas.find(x => x.id === plan?.salidaId && x.guardada);
                    return sel && !editando ? (
                        <p className="mt-1.5 px-1 text-caption text-muted">
                            {sel.direccion}{' · '}
                            <button type="button" onClick={() => onQuitarSalida(sel.direccion)} disabled={guardando} className="font-bold underline">Sacar de las guardadas</button>
                        </p>
                    ) : null;
                })()}
                {editando && (
                    <div className="mt-2 p-3 rounded-2xl bg-panel space-y-2">
                        <input value={texto} onChange={e => setTexto(e.target.value)} onKeyDown={e => e.key === 'Enter' && usar()} autoFocus
                            placeholder="Calle y altura, localidad (ej. Nicaragua 5900, CABA)" maxLength={200}
                            className="w-full h-11 px-3 rounded-xl bg-card text-body text-ink outline-none border border-black/[0.06] dark:border-white/[0.06]" />
                        <select value={empresa} onChange={e => setEmpresa(e.target.value)} aria-label="Dónde se guarda"
                            className="w-full h-11 px-3 rounded-xl bg-card text-body font-bold text-ink outline-none">
                            <option value="GUARDAR">Guardarla: queda para elegirla siempre</option>
                            <option value="">Solo para este día</option>
                            {empresas.map(x => <option key={x.clienteId} value={x.clienteId}>Guardar como depósito de {x.nombre}{x.deposito ? ' (reemplaza el actual)' : ''}</option>)}
                        </select>
                        <div className="flex gap-2">
                            <button type="button" onClick={() => setEditando(false)} className="flex-1 h-10 rounded-xl bg-chip text-secondary text-label font-black">Cancelar</button>
                            <button type="button" onClick={usar} disabled={guardando || !texto.trim()} className="flex-[2] h-10 rounded-xl bg-ink text-page text-label font-black disabled:opacity-40">
                                {guardando ? 'Buscando…' : 'Usar esta dirección'}
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
